export default "/images/vendor/flag-icon-css/flags/1x1/bd.svg?a3ae69dedf0b3ad8fb44f09bb4f11716";